import { RootPage } from '../page';
import $api from '../../api';
import { ProjectModel } from '../../models/Gen/TrackableBaseModels';
import { ProjectData } from '../../models/Gen/BaseModels';
import languages from '../../utils/languages';
import UsersView from './usersView';
import IntegrateSlackButton from '../../components/integrateSlackButton';
import DisconnectSlackButton from '../../components/disconnectSlackButton';
import ExtensionTester from '../../components/extensionTester';
import getHashOrDefault from '../../utils/getHashOrDefault';
import ActivitiesView from './activitiesView';
import ImgEx from '../../components/imgEx';
import ColorPicker from '../../components/colorPicker';
import { listenToPageDirty, resolvePageDirty } from '../../utils/changeTracking';
import { sendMessageToExtensionAsync } from '../../utils/extension';

class DashboardSettingsView extends RootPage {
    constructor() {
        super();

        ColorPicker();
        ImgEx();
        ActivitiesView();
        UsersView();
        IntegrateSlackButton();
        DisconnectSlackButton();
        ExtensionTester();

        this.isDirty = ko.observable(false);

        this.project = ko.observable();
        this.projectData = ko.observable();

        this.setActiveTab(getHashOrDefault('general'));

        this.languages = languages.sort((a, b) => (a.English > b.English) ? 1 : -1);
        this.selectedLanguageForAdd = ko.observable();
        this.selectedLanguageForAdd.subscribe(v => {
            if (v) {
                this.addSupportedLanguage(v);
            }
            this.selectedLanguageForAdd(null);
        });

        this.isIntegrationAllowed = this.isIntegrationAllowed.bind(this);

        this.allowedDomainToAdd = ko.observable();
        this.deniedDomainToAdd = ko.observable();
        this.allowedUserToAdd = ko.observable();

        this.resetAllToursUsername = ko.observable();

        const adminToolsServerSide = this.getServerSideData('adminTools');
        this.adminTools = {
            cssVersions: [
                { text: 'V2 (default)', val: 'v2' },
                { text: 'V3', val: 'v3' },
            ],
            selectedCssVersion: ko.observable(adminToolsServerSide.cssVersion),
            allProjects: adminToolsServerSide.allProjects,
            selectedCloneTargetProject: ko.observable()
        }

        listenToPageDirty((w) => {
            this.isDirty(true);
        })
    }

    onActiveTabChanging() {
        if (this.isDirty()) {

            $('.page-footer .btn-primary').focus();
            $('.page-footer').removeClass('show-anim');

            setTimeout(() => {
                $('.page-footer').addClass('show-anim');
            }, 50);

            return false;
        }
    }

    addAllowedDomain() {
        this.project().allowedDomains.push(this.allowedDomainToAdd());
        this.allowedDomainToAdd('');
    }

    removeAllowedDomain(data) {
        this.project().allowedDomains.remove(data);
    }

    addDeniedDomain() {
        this.project().deniedDomains.push(this.deniedDomainToAdd());
        this.deniedDomainToAdd('');
    }

    removeDeniedDomain(data) {
        this.project().deniedDomains.remove(data);
    }

    addAllowedUser() {
        this.project().allowedUsers.push(this.allowedUserToAdd());
        this.allowedUserToAdd('');
    }

    removeAllowedUser(data) {
        this.project().allowedUsers.remove(data);
    }

    onAtiveTabChanged(tab) {
        if (tab === 'customcss') {
            this.refreshProjectData('customCss');
        } else if (tab === 'integrations') {
            this.refreshProjectData('allowedIntegrations');
        } else if (tab === 'activityLog') {
            document.dispatchEvent(new CustomEvent('loadActivityLogs'));
        }
    }

    refreshProjectData(prop) {
        $api.projects.getData(
            { projectCode: auth.project.UniqueCode, props: prop },
            {},
            (resp) => {
                if (!this.projectData()) this.projectData(new ProjectData());

                this.projectData()[prop](resp[prop]);
            }
        );
    }

    switchIntegration(integration) {
        const pd = this.projectData();
        if (!pd) this.projectData(new ProjectData());

        if (!pd.allowedIntegrations()) pd.allowedIntegrations([]);

        if (pd.allowedIntegrations().some(i => ko.unwrap(i.type) == integration)) {
            pd.allowedIntegrations.remove(i => ko.unwrap(i.type) == integration);
        } else {
            pd.allowedIntegrations.push({ type: integration });
        }

        this.saveData('allowedIntegrations');
    }

    isIntegrationAllowed(integration) {
        return ko.computed(() => {
            const pd = this.projectData();
            if (!pd) return false;

            const ai = pd.allowedIntegrations();
            if (!ai) return false;

            return ai.some(i => ko.unwrap(i.type) == integration);
        });
    }

    onInit() {
        this.project(new ProjectModel(this.getServerSideData('project')));
    }

    addSupportedLanguage(l) {
        this.project().supportedLanguages.push(l.alpha2);
    }

    removeSupportedLanguage(item) {
        this.project().supportedLanguages.remove(item);
    }

    saveGeneralSettings() {
        this.startSubmitting('general');
        $api.projects.saveGeneral(
            { projectCode: auth.project.UniqueCode },
            this.project().toJS(),
            (resp) => {
                this.showToast('Saved.');
                this.stopSubmitting('general');

                this.isDirty(false);
                resolvePageDirty();

                sendMessageToExtensionAsync({
                    type: 'sync_single_workspace',
                    workspace: { uniqueCode: resp.uniqueCode, name: resp.name, baseUrl: resp.baseUrl, supportedLanguages: resp.supportedLanguages }
                });
            }
        );
    }

    saveAdminSettings() {
        this.startSubmitting('admintools');

        $api.projects.saveAdminSetings(
            { projectCode: auth.project.UniqueCode },
            {
                cssVersion: this.adminTools.selectedCssVersion()
            },
            (resp) => {
                this.showToast('Saved.');
                this.stopSubmitting('admintools');
            }
        );
    }

    saveData(props) {
        this.startSubmitting('customcss');

        $api.projects.saveData(
            { projectCode: auth.project.UniqueCode, props: props },
            this.projectData().toJS(),
            (resp) => {
                this.stopSubmitting('customcss');
                this.showToast('Saved.');
            }
        );
    }

    enableEncryption() {
        var value = ko.unwrap(this.project().isDataProtected);

        if (value) {
            if (confirm("Product Fruits will stop working immediately if you have not updated your Product Fruits installation code to support Identity Verification. Are you sure you want to enable this feature?")) {

                this.project().isDataProtected(value);
            }else{
                this.project().isDataProtected(false);
            }
        } else {
            this.project().isDataProtected(false);
        }

        return true;
    }

    generateHmacKey() {
        var value = ko.unwrap(this.project().encryptionKey);

        if (!value || confirm("Are you sure you want to generate new key?")) {
            if (!value || confirm("Really? It cannot be reverted")) {
                $api.projects.generateKey(
                    { projectCode: auth.project.UniqueCode },
                    {},
                    (resp) => {
                        if (resp?.key) {
                            this.project().encryptionKey(resp?.key);
                        }
                    }
                );
            }
        }
    }

    copyToClipboard() {
        navigator.clipboard.writeText(this.project().encryptionKey());
    }

    setLanguageAsDefault(index) {
        let data = ko.unwrap(this.project().supportedLanguages);
        data.unshift(data.splice(index, 1)[0]);
        this.project().supportedLanguages(data);
    }

    removeProject() {
        if (confirm('Really? It cannot be reverted.')) {
            $api.projects.remove(
                { projectCode: auth.project.UniqueCode },
                {},
                () => {
                    window.location.href = '/';
                }
            );
        }
    }

    restartAllToursForUser() {
        if (confirm('Are you sure you want to erase all tour statistics and data for the given user? It cannot be taken back.')) {
            $api.tours.restartAllToursForUser_DANGEROUS(
                { projectCode: auth.project.UniqueCode, username: encodeURIComponent(ko.unwrap(this.resetAllToursUsername)) },
                {},
                (resp) => {
                    this.showToast('Restarted!');
                    this.resetAllToursUsername('');
                }
            );
        }
    }

    switchToOldButton() {
        if (confirm('Are you sure?')) {
            TRACK_EVENT('Button', 'Switched to OLD');

            $api.projects.removeFeatureFlag(
                { projectCode: auth.project.UniqueCode, flag: 'button' },
                {},
                () => {
                    this.showToast('Reloading...');

                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                }
            );
        }
    }

    cloneFullKb(clean) {
        if (!this.adminTools.selectedCloneTargetProject()) {
            return;
        }
        if (confirm('Are you sure?')) {
            this.startSubmitting('clone-kb');
            $api.projects.cloneFullKb(
                { projectCode: auth.project.UniqueCode, newId: this.adminTools.selectedCloneTargetProject(), clean },
                {},
                () => {
                    this.showToast('Cloned!');
                    this.stopSubmitting('clone-kb');
                }
            );
        }
    }
}

export default DashboardSettingsView;
